import TabViewState, { TabState } from '../store/schema/TabViewState';
import { getStore } from '../store/tabStore';
import * as trace from 'owa-trace';

export default function getActiveContentTab(): TabViewState {
    const store = getStore();

    for (const viewState of store.tabs) {
        if (viewState.state == TabState.Active) {
            return viewState;
        }
    }

    // We should never see this happen.
    trace.errorThatWillCauseAlert('There is no active tab. Something went very wrong.');
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (19,5): Type 'null' is not assignable to type 'TabViewState'.
    // @ts-expect-error
    return null;
}
